import React from "react";
import Menusection from "../components/menu/MenuSection/MenuSection";
import MenuFooter from "../components/menu/Footer/MenuFooter";
import Menu2 from "../components/menu/MenuSection/MenuSection2";

const MenuPage = () => {
  return (
    <>
      {/* <Mheader /> */}
      <div className="Menu_Page">
        {/* <Menusection /> */}
        <Menu2 />
        <MenuFooter />
      </div>
    </>
  );
};

export default MenuPage;
